import './style/index.scss' //引入页面样式

import sensors from 'sa-sdk-javascript'

import { throttle } from './utils/throttle'
import { postWithJson } from './utils/http'

// 是否是pc
const isPC = () => {
    let userAgentInfo = navigator.userAgent;
    let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
    let flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

// 渲染普通列表
let canJump = true //移动端判断是否可跳转（防止点击添加、移除收藏按钮跳转）
let configNow = false //移动端添加、移除收藏 按钮状态保持
let isCLickNav = false //是否是手动触发导航
let modeArr = {
    'PROD': '生产环境',
    'PRE': '预发环境',
    'TEST': '测试环境',
    'DEV': '开发环境',
}
let curMode = 'PROD'
let is_pc = isPC()

const backTopDom = document.querySelector('.back-top')
const nameWrapDom = document.querySelector('.name-wrap')
const chooseModeDom = document.querySelector('.choose-mode')
const curTypeDom = document.querySelector('.cur-type')
const drapListDom = document.querySelector('.drap-list')
const drapListLiDom = drapListDom.querySelectorAll('li')
const drapDownDom = document.querySelector('.drap-down')
const shadowDom = document.querySelector('.shadow')
const oldNavDom = document.querySelector('.go-old')
const navWrapDom = document.querySelector('.ht-nav')
const navDom = document.querySelector('.ht-nav-ul')
const sectionDom = document.querySelector('.ht-section')
const bannerDom = document.querySelector('.ht-header')
const bannerStyle = bannerDom.getBoundingClientRect()
const navStyle = navDom.getBoundingClientRect()

let curModeData = localStorage.getItem('curMode')

if(curModeData){
    curModeData = JSON.parse(curModeData)
    curTypeDom.innerHTML = modeArr[curModeData]
    curMode = curModeData
    for(let i = 0; i < drapListLiDom.length; i++){
        if(drapListLiDom[i].getAttribute('mode') == curMode){
            drapListLiDom[i].className = 'active'
        }else{
            drapListLiDom[i].className = ''
        }
    }
}else{
    localStorage.setItem('curMode', JSON.stringify(curMode))

    for(let i = 0; i < drapListLiDom.length; i++){
        if(drapListLiDom[i].getAttribute('mode') == curMode){
            drapListLiDom[i].className = 'active'
        }else{
            drapListLiDom[i].className = ''
        }
    }
}

let bannerOrignHeight = bannerStyle.height
let isDrap = false

function renderNavAndSectionDom (data) {

    window.removeEventListener('scroll', throttle(liensenScroll, 1000), false)
    let navStr = ''
    let sectionStr = ''

    //生产dom字符串
    data.forEach((item, index) => {
        navStr += `<li class="ht-nav--item ${is_pc ? 'ht-nav-hover' : ''}" navIndex="${index}" data-sensors-click>
            ${item.groupName}
            ${
                item.groupName === '效率工具' ? `<p class="step step1">
                    <span>新增AI工具~</span>
                    <a class="js-step1">查看</a>
                </p>` : ''
            }
        </li>`
        sectionStr += `<article class="ht-section--item" navIndex="${index}">
            <h2>${item.groupName} ${index == 0 && !is_pc ? `<span class="manage-app">${configNow ? '完成':'管理'}</span>` : ''}</h2>
            <div class="ht-icon-box">
            ${
                item.navItems ? (item.navItems.map((child, i) => {
                    return `<div class="icon-wrap">
                        <div class="ht-section--item__icons" data-url="${child.navUrl}" data-sensors-click>
                                    <span class="icon ${item.groupName == '运维开发工具' ? 'ywgj-icon' : ''}">
                                        <i class="manage-icon ${item.groupName == '我常用的' ? 'cut' : 'add'}" dataid='${child.id}' style="${configNow?'display:block': ''}"></i>
                                        ${child.needVpn ? `<em class="vpn" style="${configNow?'display: none': ''};"></em>` : ''}
                                        <img class="${item.groupName == '运维开发工具' ? 'ywgj' : ''}" src="${child.navIconUrl}"/>
                                    </span>
                                <span class="text">${child.name}</span>
                        </div>
                    </div>`
                }).join('')) : ''
            }
            </div>
        </article>`
    });

    //插入列表
    navDom.innerHTML = navStr
    sectionDom.innerHTML = sectionStr

    //dom生成后获取
    const allNavs = document.querySelectorAll('.ht-nav--item')
    const allSections = document.querySelectorAll('.ht-section--item')
    const iconsDom = document.querySelectorAll('.ht-section--item__icons')
    const manageAppDom = document.querySelector('.manage-app')

    //获取所有section中article样式
    const getAllSections = () => {
        let styleObj = []

        allSections.forEach((item) => {
            const { top, height } = item.getBoundingClientRect()
            let navIndex =  item.getAttribute('navIndex')

            styleObj.push({
                top,
                height,
                navIndex
            })
        })

        return styleObj
    }

    //设置原始class
    const setOriginClass = () => {
        allNavs.forEach((item) => {
            item.className = `ht-nav--item ${is_pc ? 'ht-nav-hover': ''}`
        })
    }

    // 注册导航点击事件
    navDom.onclick = function (e) {
        if(e.target.nodeName != 'LI') return

        isCLickNav = true
        setOriginClass()
        e.target.className = 'ht-nav--item active'

        let curIndex = Number(e.target.getAttribute('navIndex'))

        const { top } = allSections[curIndex].getBoundingClientRect()
        const { height, width } = navDom.getBoundingClientRect()
        const targetLeft = e.target.getBoundingClientRect().left

        if(!is_pc && targetLeft > width/2){
            navDom.scrollLeft += allNavs[curIndex].scrollWidth
        }else{
            navDom.scrollLeft -= allNavs[curIndex].scrollWidth
        }


        window.scrollTo(0, top + window.scrollY - 2*height)
        setTimeout(()=>{
            isCLickNav = false
        },20)
    }

    //给加减号添加事件
    for(let i = 0, len = iconsDom.length; i < len; i++){
        iconsDom[i].onclick = function (e) {
            let curTarget = e.target
            if(curTarget.className.indexOf('add') > -1){
                let curId = curTarget.getAttribute('dataid')
                !localStorage.getItem('hasGuide') && localStorage.setItem('hasGuide', JSON.stringify(true))
                addDailyApp(Number(curId))
            }else if(curTarget.className.indexOf('cut') > -1){
                let curId = JSON.parse(curTarget.getAttribute('dataid'))
                cutDailyApp(Number(curId))
            } else if(curTarget.tagName != 'I' && curTarget.className != 'js-step2'){
                canJump && window.open(iconsDom[i].getAttribute('data-url'))
            }
        }
    }



    //监听滚动
    let sectionScrollH = sectionDom.scrollHeight
    let navScrollW = navDom.scrollWidth
    let ratio = sectionScrollH / navScrollW
    let preScrollTop = 0


    function liensenScroll(e) {
        if(isCLickNav) return
        let sectionStyle = getAllSections()
        let curTop = document.documentElement.scrollTop

        if(curTop>200){
            backTopDom.style.display = 'block'
        }else{
            backTopDom.style.display = 'none'
        }


        if(!localStorage.getItem('hideBanner') && localStorage.getItem('hasGuide') && is_pc && !isDrap && preScrollTop < curTop - 100){
            bannerDom.setAttribute('style', `position:sticky;height:${navStyle.height}px;background:#ffffff;z-index:9999;`)
            bannerDom.style.setProperty('--header-name-color', '#292B2C')
            bannerDom.style.setProperty('--header-logo-bg', `url(http://htwuhan.oss-cn-beijing.aliyuncs.com/daohang/logo-gray.png) 0 0 no-repeat`)
            navWrapDom.style.top = `${navStyle.height}px`
            navWrapDom.style.setProperty('--nav-height-f', `${navStyle.height}px`)
            bannerStyle.height = navStyle.height
            shadowDom.style.display = 'block'
            nameWrapDom.setAttribute('style', 'display: none;')
            chooseModeDom.className = 'choose-mode banner-mode'
            drapDownDom.setAttribute('style', `display: block; opacity: 1;`)

            localStorage.setItem('hideBanner', JSON.stringify(true))
        }
        preScrollTop = curTop

        if(curTop < bannerStyle.height - navStyle.height){
            setOriginClass()
            navDom.scrollLeft = 0

            return
        }
        try{
            sectionStyle.forEach((item) => {
                if(Math.abs(item.top) <= item.height/2 ){
                    setOriginClass()
                    allNavs[item.navIndex].className = 'ht-nav--item active'
                    !is_pc && (navDom.scrollLeft = (window.scrollY - bannerStyle.height- 3*navStyle.height)/ratio) //改变导航横向滚动
                    throw Error();
                }
            });
        }catch(e){}
    }
    window.addEventListener('scroll', throttle(liensenScroll, 200), false)

    // 新手引导
    const guideHandler = () => {
        const step1Dom = document.querySelector('.step1')
        // const step2Dom = document.querySelector('.step2')

        const jsStep1Dom = document.querySelector('.js-step1')
        // const jsStep2Dom = document.querySelector('.js-step2')

        step1Dom.style.display = 'flex'

        jsStep1Dom.onclick = function (e) {
            let curIndex = data.findIndex(item => item.groupName === '效率工具')
            const { top } = allSections[curIndex].getBoundingClientRect()
            const { height } = navDom.getBoundingClientRect()

            window.scrollTo(0, top + window.scrollY - 2*height)
            step1Dom.style.display = 'none'

            setTimeout(() => {
                localStorage.setItem('hasGuide', JSON.stringify(true))
            }, 1000)
            // step2Dom.style.display = 'flex'
        }

        // jsStep2Dom.onclick = function (e) {
            // step2Dom.style.display = 'none'
        // }
    }

    //修改样式移动端点击管理后
    if(!is_pc){
        const vpnsDom = document.querySelectorAll('.vpn')
        const manageIconsDom = document.querySelectorAll('.manage-icon')
        manageAppDom.onclick = function (e) {
            for(let i = 0, len = manageIconsDom.length; i < len; i ++){
                if(manageIconsDom[i].style.display == 'block'){
                    canJump = true
                    configNow = false
                    manageAppDom.innerHTML = '管理'
                    manageIconsDom[i].style.display = 'none'
                    vpnsDom[i] && (vpnsDom[i].style.display = 'block')
                }else {
                    canJump = false
                    configNow = true
                    manageAppDom.innerHTML = '完成'
                    manageIconsDom[i].style.display = 'block'
                    vpnsDom[i] && (vpnsDom[i].style.display = 'none')
                }

            }
        }
    }else{
        // canJump = true
        configNow = false
    }

    let hasGuide = localStorage.getItem('hasGuide')
    if(is_pc && !JSON.stringify(data).includes('我常用的') && (!hasGuide || !JSON.parse(hasGuide))){
        guideHandler()
    }
}




// 添加收藏
function addDailyApp(id) {
    postWithJson('/nav/collect.json', {navId: id}).then(async () => {

        const collectList = await getCollectData()

        groupData[0].groupName == '我常用的' && groupData.shift()

        let collectData = collectList.data
        collectData && collectData.length && groupData.unshift({
            groupName: '我常用的',
            navItems: collectData
        })
        await renderNavAndSectionDom(groupData)
    })
}



//移除收藏
function cutDailyApp(id) {
    postWithJson('/nav/removeCollect.json', {navId: id}).then(async res=>{
        groupData.shift()

        const collectList = await getCollectData()

        let collectData = collectList.data
        collectData && collectData.length && groupData.unshift({
            groupName: '我常用的',
            navItems: collectData
        })

        await renderNavAndSectionDom(groupData)
    })
}

// 获取收藏列表数据
function getCollectData() {
    return postWithJson('/nav/collectList.json', {envType: curMode})
}

// 获取所有数据
function getAllData () {
    return postWithJson('/nav/groupList.json', {envType: curMode})
}

// 获取用户信息 todo: 工号
let groupData = []
postWithJson('/auth/checkLogin.json', {}).then(async res=>{
    const { avatar, name, staffNo } = res.data
    const avaterDom = document.querySelector('.user-avater')
    const nameDom = document.querySelector('.user-name')

    avatar && (avaterDom.innerHTML =  `<img src="${avatar||''}" />`)
    name && (nameDom.innerHTML =  `${name||''}(${staffNo||''})`)

    await fetchData()

})

async function fetchData(){
    try{
        const groupList = await getAllData()
        const collectList = await getCollectData()

        groupData = groupList.data
        let collectData = collectList.data
        if(collectData && collectData.length) {
            groupData.unshift({
                groupName: '我常用的',
                navItems: collectData
            })
            localStorage.setItem('hasGuide', JSON.stringify(true))
        }

        await renderNavAndSectionDom(groupData)


    }catch(e){

    }
}



if(localStorage.getItem('hideBanner') && localStorage.getItem('hasGuide') && is_pc){
    drapDownDom.setAttribute('style', `display: block; opacity: 1;`)
    bannerDom.setAttribute('style', `position:sticky;height:${navStyle.height}px;background:#ffffff;z-index:9999;`)
    bannerDom.style.setProperty('--header-name-color', '#292B2C')
    bannerDom.style.setProperty('--header-logo-bg', `url(http://htwuhan.oss-cn-beijing.aliyuncs.com/daohang/logo-gray.png) 0 0 no-repeat`)
    navWrapDom.style.setProperty('--nav-height-f', `${navStyle.height}px`)
    bannerStyle.height = navStyle.height
    shadowDom.style.display = 'block'
    nameWrapDom.setAttribute('style', 'display: none;')
    chooseModeDom.className = 'choose-mode banner-mode'

    localStorage.setItem('hideBanner', JSON.stringify(true))
}


if(is_pc){
    drapDownDom.onclick = function(e) {
        isDrap = true
        drapDownDom.setAttribute('style', `display: none; opacity: 0;`)
        // bannerDom.setAttribute('style', `transition: height .5s ease-in-out; position: sticky;z-index: 9999;height: ${bannerOrignHeight}px;`)
        bannerDom.setAttribute('style', `transition: height .5s ease-in-out; height: ${bannerOrignHeight}px;`)
        navWrapDom.setAttribute('style', ``)
        oldNavDom.setAttribute('style', '')
        bannerStyle.height = bannerOrignHeight
        shadowDom.style.display = 'none'
        nameWrapDom.setAttribute('style', 'display: block;')
        chooseModeDom.className = 'choose-mode'

        localStorage.removeItem('hideBanner')

        setTimeout(() => {isDrap = false}, 2000)
    }
}

backTopDom.onclick = function(){
    window.scrollTo(0,0)
}

curTypeDom.onclick = function(){
    if(drapListDom.style.opacity == 0){
        drapListDom.setAttribute('style', `opacity: 1;transition: opacity .5s ease-in-out;visibility: visible`)
    }else{
        drapListDom.setAttribute('style', `opacity: 0;transition: opacity .5s ease-in-out;visibility: hidden`)
    }
}


drapListDom.onclick = async function (e){
    if(e.target.nodeName != 'LI' || e.target.className.indexOf('active')>-1) return
    curTypeDom.innerHTML = e.target.innerHTML
    curMode = e.target.getAttribute('mode')

    for(let i = 0; i < drapListLiDom.length; i++){
        drapListLiDom[i].className = ''
    }
    e.target.className = 'active'
    drapListDom.setAttribute('style', `opacity: 0;transition: opacity .5s ease-in-out;visibility: hidden`)

    localStorage.setItem('curMode', JSON.stringify(curMode))

    await fetchData()
    window.scrollTo(0, 0)
}

sensors.init({
    server_url: window.location.href.indexOf('https://daohang.huatu.com') !== -1
        ? 'https://datax-api.huatu.com/sa?project=production'
        : 'https://datax-api.huatu.com/sa?project=default',

    heatmap: {
        // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        clickmap: 'default',

        // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        scroll_notice_map: 'default'
    }
})

sensors.registerPage({
    business_line: '教育',
    platform: 'M站',
    product_name: '华图新导航',
})
